import {IRpcDeleteResponse} from 'shared/types/rpc';
import {performRequest} from 'shared/utils';

import {IReportConfigurationDataDto} from '../report-configuration-dto';
import {IReportDdParameter} from './dd-parameters-configuration-types';

const ddParametersEndpoint = 'table-reports/drill-down-parameters';

export interface IFetchDDChildReportQueryParametersArgs {
    templateCode: string;
}
export const fetchDDChildReportQueryParameters = (
    params: IFetchDDChildReportQueryParametersArgs,
) => performRequest<
    {queryParameters: IReportConfigurationDataDto['queryParameters']}
>({
    url: `table-reports/${params?.templateCode}/config/field/queryParameters`,
    method: 'GET',
    params,
});

export interface IFetchDrillDownParametersArgs {
    drillId: string;
}
export const fetchDrillDownParameters = (
    params: IFetchDrillDownParametersArgs,
) => performRequest<IReportDdParameter[]>({
    url: `${ddParametersEndpoint}/${params?.drillId}`,
    method: 'GET',
});

export type TDrillDownParameterPostRequestArgs = Partial<IReportDdParameter>;
export const postDrillDownOarameter = (
    args: TDrillDownParameterPostRequestArgs,
) => performRequest<IReportDdParameter>({
    url: [ddParametersEndpoint].join('/'),
    method: 'POST',
    data: args,
});

export type TDeleteDrillDownParameterRequestArgs = {id: number};
export const deleteDrillDownParameterRequest = (
    args: TDeleteDrillDownParameterRequestArgs,
) => performRequest<IRpcDeleteResponse>({
    url: [ddParametersEndpoint, args.id].join('/'),
    method: 'DELETE',
});
